import { render } from "./Cookies.vue?vue&type=template&id=78d83d60"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adityabhimrajka/Documents/Solutions/Super & Uber/Go-Jek/MoxJek/1.7.44/Web Extension/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__